import { ReactNode, useContext } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import ImgWaterMark from "../assets/img/common/watermark.png";
import { WrapperContext } from "./WrapperContext.tsx";

interface PageTemplateProps {
  children: ReactNode;
  headerData: object;
  bannerImage: object;
}

const Main = styled.div`
  width: 100%;
  padding-top: 60px;
`;

const Banner = styled.div`
  width: 100%;
  height: 25vw;
  background: url(${(props) => props.src || ""});
  background-size: cover;
`;

const Wrapper = styled.div`
  display: flex;
  min-height: calc(100vh - 350px);
  margin: ${(props) => (!props.isMobile ? "0px 13%" : "0px")};
  padding: ${(props) => (!props.isMobile ? "0px 2%" : "0px")};
  background: url(${ImgWaterMark});
  background-size: contain;
  padding-top: ${(props) => (!props.isMobile ? "35px" : "0px")};
`;

const MenubarWrapper = styled.div`
  height: fit-content;
  text-align: left;
  position: sticky;
  top: 80px;
  transition: top 2s ease-in-out;
`;
const MainMenuText = styled.div`
  font-size: 18px;
  font-family: SCDream7;
  margin-bottom: 7px;
  color: #00273d;
`;
const Navigator = styled.ul`
  display: inline-block;
  width: 165px;
  background: #00273d;
  list-style: none;
  padding: 10px 0;
  margin: 0;
  height: fit-content;
`;
const NavigatorMenu = styled.li`
  width: 100%;
  height: 50px;
  color: ${(props) => (props.selected ? "#F7C967" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const ContentWrapper = styled.div`
  display: inline-block;
  width: ${(props) => (!props.isMobile ? "calc(100% - 190px)" : "100%")};
  padding-left: 18px;
  padding-right: ${(props) => (!props.isMobile ? "0px" : "18px")};
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  width: calc(100% + 15vw + 4px);
  height: 50px;
  background-color: #003b5d1a;
  align-items: center;
  padding-left: 15px;
  font-size: 18px;
  font-family: SCDream7;
  color: #00273d;
`;

export default function PageTemplate(props: PageTemplateProps) {
  const { headerData, isMobile } = useContext(WrapperContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = headerData.find((menu) => pathname.startsWith(menu.href));
  let selectedTitle = current.name; // 하위 메뉴가 없는 케이스 때문에 기본 값은 메인 메뉴로

  return (
    <Main>
      <Banner src={props.bannerImage} />
      <Wrapper isMobile={isMobile}>
        {!isMobile ? (
          <MenubarWrapper>
            <MainMenuText>{current.name}</MainMenuText>
            <Navigator>
              {current.children?.map((child, idx) => {
                const selected = pathname.startsWith(child.href);
                if (pathname.startsWith(child.href)) {
                  selectedTitle = child.name;
                }
                return (
                  <NavigatorMenu
                    selected={selected}
                    key={`menu${idx}`}
                    onClick={() => {
                      navigate(child.href);
                      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                    }}
                  >
                    {child.name}
                  </NavigatorMenu>
                );
              })}
            </Navigator>
          </MenubarWrapper>
        ) : null}
        <ContentWrapper isMobile={isMobile}>
          {!isMobile ? <Title>{selectedTitle}</Title> : null}
          <Content>{props.children}</Content>
        </ContentWrapper>
      </Wrapper>
    </Main>
  );
}
